(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var active = null;

  function visibleFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return !el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true" && el.offsetParent !== null;
    });
  }

  window.LRFocusTrap = {
    activate: function (container, preferred) {
      window.LRFocusTrap.deactivate();
      if (!container) return;
      var previouslyFocused = document.activeElement;
      var onKey = function (e) {
        if (e.key !== "Tab") return;
        var nodes = visibleFocusable(container);
        if (!nodes.length) return;
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      container.addEventListener("keydown", onKey);
      active = { container: container, onKey: onKey, previouslyFocused: previouslyFocused };
      var target = preferred && container.contains(preferred) ? preferred : visibleFocusable(container)[0];
      if (target && typeof target.focus === "function") {
        window.setTimeout(function () {
          target.focus();
        }, 0);
      }
    },
    deactivate: function () {
      if (!active) return;
      active.container.removeEventListener("keydown", active.onKey);
      var prev = active.previouslyFocused;
      active = null;
      if (prev && typeof prev.focus === "function") {
        try {
          prev.focus();
        } catch (err) {
          /* ignore */
        }
      }
    },
  };
})();

(function () {
  var headerGroup = document.getElementById("header-group");
  if (!headerGroup) return;

  var scrollRoot =
    document.querySelector(".page-wrapper") || document.documentElement;

  var getScrollY = function () {
    if (scrollRoot === document.documentElement) {
      return window.scrollY || document.documentElement.scrollTop || 0;
    }
    return scrollRoot.scrollTop || window.scrollY || 0;
  };

  var onScroll = function () {
    headerGroup.classList.toggle("is-scrolled", getScrollY() > 24);
  };

  onScroll();
  scrollRoot.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("scroll", onScroll, { passive: true });

  var menuOpen = document.querySelector("[data-lr-menu-open]");
  var mobileNav = document.getElementById("lr-mobile-nav");
  if (!menuOpen || !mobileNav) return;

  var panel = mobileNav.querySelector(".lr-mobile-nav__panel");
  var openMenu = function () {
    mobileNav.hidden = false;
    mobileNav.setAttribute("aria-hidden", "false");
    menuOpen.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    if (panel) panel.focus();
  };
  var closeMenu = function () {
    mobileNav.hidden = true;
    mobileNav.setAttribute("aria-hidden", "true");
    menuOpen.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  };

  menuOpen.addEventListener("click", openMenu);
  mobileNav.querySelectorAll("[data-lr-menu-close]").forEach(function (el) {
    el.addEventListener("click", closeMenu);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !mobileNav.hidden) closeMenu();
  });
})();

(function () {
  var pad2 = function (n) {
    n = parseInt(n, 10) || 0;
    return n < 10 ? "0" + n : String(n);
  };

  var SECTION_ID = "cart-drawer-section";

  var syncCartDrawer = function (itemCount) {
    var drawer = document.querySelector(".lr-cart-drawer");
    if (!drawer) return;

    var hasLines =
      drawer.querySelector(".lr-cart-line, .cart-items__table-row, [data-lr-cart-line]") !== null;
    var emptyMarker = drawer.querySelector("[data-cart-drawer-empty]") !== null;
    var empty = itemCount === 0 || (emptyMarker && !hasLines);
    if (itemCount > 0 && hasLines) empty = false;

    drawer.classList.toggle("cart-drawer--empty", empty);

    var countEl = drawer.querySelector("[data-lr-cart-drawer-count]");
    if (!countEl) return;
    var next = pad2(itemCount) + " ITEMS";
    if (countEl.textContent !== next) countEl.textContent = next;
  };

  var syncEmptyClassFromDom = function () {
    var drawer = document.querySelector(".lr-cart-drawer");
    if (!drawer) return;
    var isEmpty = drawer.querySelector("[data-cart-drawer-empty]") !== null;
    drawer.classList.toggle("cart-drawer--empty", isEmpty);
    if (isEmpty) syncCartDrawer(0);
  };

  var syncQtyDisplays = function () {
    document.querySelectorAll("#cart-drawer .lr-qty").forEach(function (selector) {
      var input = selector.querySelector("input[type='number']");
      var valueEl = selector.querySelector(".lr-qty__value");
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n)) return;
      var padded = pad2(n);
      if (selector.getAttribute("data-lr-qty") !== padded) {
        selector.setAttribute("data-lr-qty", padded);
      }
      if (valueEl && valueEl.textContent !== padded) {
        valueEl.textContent = padded;
      }
    });
  };

  var bindDiscountToggles = function (root) {
    var scope = root || document;
    scope.querySelectorAll("[data-lr-discount]").forEach(function (el) {
      if (el.dataset.lrBound === "1") return;
      el.dataset.lrBound = "1";
      var toggle = el.querySelector("[data-lr-discount-toggle]");
      var panel = el.querySelector("[data-lr-discount-panel]");
      var icon = el.querySelector(".lr-cart-discount__icon");
      if (!toggle || !panel) return;

      toggle.addEventListener("click", function () {
        var open = !panel.classList.contains("is-open");
        panel.classList.toggle("is-open", open);
        if (icon) icon.classList.toggle("is-open", open);
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  };

  var refreshCartUi = function () {
    syncEmptyClassFromDom();
    syncQtyDisplays();
    bindDiscountToggles();
  };

  document.addEventListener("shopify:cart:lines-update", function (event) {
    /* Don't sync empty-from-DOM before morph — stale empty shell would
       force cart-drawer--empty / 00 ITEMS while the add is in flight. */
    syncQtyDisplays();
    bindDiscountToggles();

    var promise = event.promise;
    if (!promise || typeof promise.then !== "function") {
      refreshCartUi();
      return;
    }

    promise
      .then(function (result) {
        var cart = result && result.cart;
        var detail = result && result.detail;
        var count = -1;
        if (cart && typeof cart.totalQuantity === "number") count = cart.totalQuantity;
        else if (cart && typeof cart.item_count === "number") count = cart.item_count;

        if (count >= 0) syncCartDrawer(count);
        syncQtyDisplays();
        bindDiscountToggles();

        /* Let Horizon morph first; only re-fetch if empty shell is still stuck */
        if (count > 0 && document.querySelector("#cart-drawer [data-cart-drawer-empty]")) {
          window.setTimeout(function () {
            if (!document.querySelector("#cart-drawer [data-cart-drawer-empty]")) return;
            var html = detail && detail.sections && detail.sections[SECTION_ID];
            if (html) {
              morphCartDrawerSection(html);
            } else {
              import("@theme/section-renderer")
                .then(function (mod) {
                  return mod.sectionRenderer.renderSection(SECTION_ID, {
                    cache: false,
                    mode: "hydration",
                    injectStylesheet: true,
                  });
                })
                .catch(function () {});
            }
          }, 50);
        } else {
          syncEmptyClassFromDom();
        }
      })
      .catch(function () {
        refreshCartUi();
      });
  });

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest("#cart-drawer .lr-qty")) {
        window.setTimeout(syncQtyDisplays, 0);
      }
    },
    true
  );

  /* ── Discount apply / remove (AJAX, no nested <form>) ────────── */

  var ensureCartDrawerOpen = function () {
    var drawer = document.getElementById("cart-drawer");
    if (!drawer) return;
    if (typeof drawer.open === "function" && drawer.isOpen === false) {
      drawer.open();
      return;
    }
    var dialog = drawer.querySelector("dialog");
    if (dialog && !dialog.open && typeof drawer.open === "function") {
      drawer.open();
    }
  };

  /**
   * Hydration morph only — never replace the whole section (that destroys the
   * open <dialog> and makes the cart vanish until reopened).
   */
  var morphCartDrawerSection = function (html) {
    if (!html) return Promise.resolve();

    return import("@theme/section-renderer")
      .then(function (mod) {
        return mod.morphSection(SECTION_ID, html, { mode: "hydration" });
      })
      .catch(function () {
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var live = document.querySelector(
          "#cart-drawer [data-hydration-key='cart-drawer-inner']"
        );
        var next = parsed.querySelector(
          "[data-hydration-key='cart-drawer-inner']"
        );
        if (live && next) live.innerHTML = next.innerHTML;
      })
      .then(function () {
        ensureCartDrawerOpen();
        bindDiscountToggles();
        bindDiscountActions();
        syncQtyDisplays();
        syncEmptyClassFromDom();
      });
  };

  var applyDiscountCode = function (code) {
    if (!code || !code.trim()) return;

    var existingCodes = [];
    document.querySelectorAll("#cart-drawer .cart-discount__pill").forEach(function (pill) {
      if (pill.dataset.discountCode) existingCodes.push(pill.dataset.discountCode);
    });

    var allCodes = existingCodes.concat([code.trim()]);

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/update.js" : "/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: allCodes.join(","), sections: [SECTION_ID] }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var notApplicable = (data.discount_codes || []).find(function (d) {
          return d.code === code.trim() && d.applicable === false;
        });

        var errorEl = document.querySelector("#cart-drawer .lr-cart-discount__error");
        var errorCodeEl = document.querySelector("#cart-drawer [ref='cartDiscountErrorDiscountCode']");
        var errorShipEl = document.querySelector("#cart-drawer [ref='cartDiscountErrorShipping']");

        if (notApplicable) {
          if (errorEl) errorEl.classList.remove("hidden");
          if (errorCodeEl) errorCodeEl.classList.remove("hidden");
          return;
        }

        if (errorEl) errorEl.classList.add("hidden");
        if (errorCodeEl) errorCodeEl.classList.add("hidden");
        if (errorShipEl) errorShipEl.classList.add("hidden");

        var input = document.querySelector("#cart-drawer .lr-cart-discount__input");
        if (input) input.value = "";

        return morphCartDrawerSection(data.sections && data.sections[SECTION_ID]);
      })
      .catch(function (err) {
        console.error("Discount apply error:", err);
      });
  };

  var removeDiscountCode = function (code) {
    var existingCodes = [];
    document.querySelectorAll("#cart-drawer .cart-discount__pill").forEach(function (pill) {
      if (pill.dataset.discountCode && pill.dataset.discountCode !== code) {
        existingCodes.push(pill.dataset.discountCode);
      }
    });

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/update.js" : "/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: existingCodes.join(","), sections: [SECTION_ID] }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return morphCartDrawerSection(data.sections && data.sections[SECTION_ID]);
      })
      .catch(function (err) {
        console.error("Discount remove error:", err);
      });
  };

  var bindDiscountActions = function () {
    // Bind apply buttons
    document.querySelectorAll("#cart-drawer [data-lr-discount-apply]").forEach(function (btn) {
      if (btn.dataset.lrDiscountBound === "1") return;
      btn.dataset.lrDiscountBound = "1";
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var form = btn.closest("[data-lr-discount-form]");
        if (!form) return;
        var input = form.querySelector(".lr-cart-discount__input");
        if (!input || !input.value.trim()) return;
        applyDiscountCode(input.value);
      });
    });

    // Bind enter key on input
    document.querySelectorAll("#cart-drawer .lr-cart-discount__input").forEach(function (input) {
      if (input.dataset.lrDiscountBound === "1") return;
      input.dataset.lrDiscountBound = "1";
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
          if (input.value.trim()) applyDiscountCode(input.value);
        }
      });
    });

    // Bind remove buttons
    document.querySelectorAll("#cart-drawer [data-lr-discount-remove]").forEach(function (btn) {
      if (btn.dataset.lrDiscountBound === "1") return;
      btn.dataset.lrDiscountBound = "1";
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pill = btn.closest(".cart-discount__pill");
        if (!pill || !pill.dataset.discountCode) return;
        removeDiscountCode(pill.dataset.discountCode);
      });
    });
  };

  // Bind once on load; re-bind after section morphs via cart events only.
  // Do NOT use MutationObserver here — writing textContent triggers childList
  // mutations and causes an infinite loop / tab crash.
  bindDiscountToggles();
  bindDiscountActions();
  syncQtyDisplays();
})();

/* ── Quick Add (product cards) ─────────────────────────────────── */
(function () {
  if (window.LR_PRE_LAUNCH) return;

  var SECTION_ID = "cart-drawer-section";

  function openCartDrawer() {
    var drawer = document.getElementById("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return;
    }
    var trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
  }

  function collectSectionIds() {
    var ids = [];
    document.querySelectorAll("cart-items-component").forEach(function (el) {
      if (el.dataset && el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) {
        ids.push(el.dataset.sectionId);
      }
    });
    if (ids.indexOf(SECTION_ID) === -1) ids.push(SECTION_ID);
    return ids;
  }

  /**
   * Same pattern as PDP: cart/add.js (+ sections) → cart.js → CustomEvent
   * so Horizon cart-items-component morphs the drawer. Avoids importing
   * @shopify/events from a classic script (that was breaking Add to cart).
   */
  function addToCart(variantId, qty) {
    var quantity = qty || 1;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    var sectionIds = collectSectionIds();

    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: quantity }],
        sections: sectionIds.join(","),
        sections_url: window.location.pathname,
      }),
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            throw new Error(data.description || data.message || "Add to cart failed");
          }
          return data;
        });
      })
      .then(function (data) {
        return fetch(root + "cart.js", {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (cartData) {
            var sections = data.sections || null;
            var resolve;
            var promise = new Promise(function (res) {
              resolve = res;
            });

            var finish = function (sectionMap) {
              resolve({
                cart: {
                  totalQuantity: cartData.item_count,
                  id: cartData.token,
                },
                detail: {
                  sections: sectionMap || {},
                  items: cartData.items,
                  itemCount: cartData.item_count,
                  source: "lr-quick-add",
                  didError: false,
                },
              });
            };

            if (sections && sections[SECTION_ID]) {
              finish(sections);
            } else {
              fetch("/?sections=" + encodeURIComponent(SECTION_ID), { credentials: "same-origin" })
                .then(function (r) {
                  return r.json();
                })
                .then(finish)
                .catch(function () {
                  finish({});
                });
            }

            var event = new CustomEvent("shopify:cart:lines-update", {
              bubbles: true,
              cancelable: false,
            });
            event.action = "add";
            event.promise = promise;
            document.dispatchEvent(event);
          });
      });
  }

  function findVariant(variants, colour, size) {
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      var colourMatch = !colour || opts.some(function (o) { return String(o).toLowerCase() === colour.toLowerCase(); });
      var sizeMatch = !size || opts.some(function (o) { return String(o).toLowerCase() === size.toLowerCase(); });
      if (colourMatch && sizeMatch) return variants[i];
    }
    return null;
  }

  function bindQuickAdd(card) {
    if (card.dataset.lrQaBound === "1") return;
    card.dataset.lrQaBound = "1";

    var modal = card.querySelector("[data-lr-quick-add]");
    var openBtn = card.querySelector("[data-lr-quick-open]");
    if (!modal || !openBtn) return;

    var variantsEl = modal.querySelector("[data-lr-qa-variants]");
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent || "[]"); } catch (e) {}

    var colour = "";
    var size = null;
    var noSize = Boolean(modal.querySelector("[data-lr-qa-no-size]"));
    var colourFixed = modal.querySelector("[data-lr-qa-colour-fixed]");
    if (colourFixed) colour = colourFixed.value;
    var firstSwatch = modal.querySelector("[data-lr-qa-colour]");
    if (firstSwatch && !colour) colour = firstSwatch.getAttribute("data-lr-qa-colour") || "";

    var colourLabel = modal.querySelector("[data-lr-qa-colour-label]");
    var hint = modal.querySelector("[data-lr-qa-hint]");
    var addBtn = modal.querySelector("[data-lr-qa-add]");
    var sizeBtns = modal.querySelectorAll("[data-lr-qa-size]");
    var homeParent = modal.parentNode;
    var qty = 1;
    var qtyValue = modal.querySelector("[data-lr-qa-qty-value]");

    function setQty(n) {
      qty = Math.max(1, Math.min(10, n));
      if (qtyValue) qtyValue.textContent = String(qty);
    }

    var qtyDec = modal.querySelector("[data-lr-qa-qty-dec]");
    var qtyInc = modal.querySelector("[data-lr-qa-qty-inc]");
    if (qtyDec) qtyDec.addEventListener("click", function () { setQty(qty - 1); });
    if (qtyInc) qtyInc.addEventListener("click", function () { setQty(qty + 1); });

    /* Pre-select the first in-stock size (same as the PDP default) */
    function syncSizes() {
      var firstAvailable = null;
      sizeBtns.forEach(function (btn) {
        var s = btn.getAttribute("data-lr-qa-size");
        var v = findVariant(variants, colour, s);
        var available = v && v.available;
        btn.disabled = !available;
        btn.classList.toggle("is-disabled", !available);
        if (!available && size === s) size = null;
        if (available && firstAvailable === null) firstAvailable = s;
      });
      if (!size && firstAvailable) size = firstAvailable;
      syncCta();
    }

    function syncCta() {
      sizeBtns.forEach(function (btn) {
        btn.classList.toggle("is-selected", btn.getAttribute("data-lr-qa-size") === size);
        btn.setAttribute("aria-pressed", btn.getAttribute("data-lr-qa-size") === size ? "true" : "false");
      });
      if (noSize) {
        var sole = variants.find(function (v) { return v.available; }) || variants[0];
        if (!sole || !sole.available) {
          addBtn.textContent = "Sold out";
          addBtn.disabled = true;
        } else {
          addBtn.textContent = "Add to cart";
          addBtn.disabled = false;
        }
        return;
      }
      var v = findVariant(variants, colour, size);
      if (!size) {
        addBtn.textContent = "Select a size";
        addBtn.disabled = false;
      } else if (!v || !v.available) {
        addBtn.textContent = "Sold out";
        addBtn.disabled = true;
      } else {
        addBtn.textContent = "Add to cart";
        addBtn.disabled = false;
      }
    }

    function open() {
      /* Portal to body so fixed sheet isn't clipped by card/grid overflow */
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
      modal.classList.remove("hidden");
      document.body.style.overflow = "hidden";
      setQty(1);
      syncSizes();
      if (window.LRFocusTrap) {
        window.LRFocusTrap.activate(modal, modal.querySelector("[data-lr-quick-close]"));
      }
    }
    function close() {
      modal.classList.add("hidden");
      document.body.style.overflow = "";
      if (hint) hint.classList.add("hidden");
      if (window.LRFocusTrap) window.LRFocusTrap.deactivate();
      if (homeParent && modal.parentNode !== homeParent) {
        homeParent.appendChild(modal);
      }
    }

    openBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      open();
    });

    modal.querySelectorAll("[data-lr-quick-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    modal.addEventListener("lr-quick-add-escape", close);

    modal.querySelectorAll("[data-lr-qa-colour]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        colour = btn.getAttribute("data-lr-qa-colour") || "";
        if (colourLabel) colourLabel.textContent = colour;
        modal.querySelectorAll("[data-lr-qa-colour]").forEach(function (b) {
          b.classList.toggle("is-selected", b === btn);
          b.setAttribute("aria-pressed", b === btn ? "true" : "false");
        });
        syncSizes();
      });
    });

    sizeBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        size = btn.getAttribute("data-lr-qa-size");
        if (hint) hint.classList.add("hidden");
        syncCta();
      });
    });

    addBtn.addEventListener("click", function () {
      var v;
      if (noSize) {
        v = variants.find(function (item) { return item.available; }) || variants[0];
      } else {
        if (!size) {
          if (hint) hint.classList.remove("hidden");
          return;
        }
        v = findVariant(variants, colour, size);
      }
      if (!v || !v.available) return;
      addBtn.disabled = true;
      addBtn.textContent = "Adding…";
      addToCart(v.id, qty)
        .then(function () {
          close();
          setTimeout(openCartDrawer, 120);
        })
        .catch(function () {
          addBtn.textContent = "Add to cart";
          addBtn.disabled = false;
        });
    });
  }

  document.querySelectorAll("[data-lr-product-card]").forEach(bindQuickAdd);

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll("[data-lr-quick-add]:not(.hidden)").forEach(function (modal) {
      modal.dispatchEvent(new Event("lr-quick-add-escape"));
      modal.classList.add("hidden");
    });
    document.body.style.overflow = "";
    if (window.LRFocusTrap) window.LRFocusTrap.deactivate();
  });

  window.lrBindQuickAdd = bindQuickAdd;
})();

/* ── Related products via Shopify recommendations API ──────────── */
(function () {
  function loadRelated(mount) {
    var url = mount.getAttribute("data-url");
    if (!url) return;
    fetch(url, { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("recommendations " + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var section =
          doc.querySelector(".shopify-section") ||
          doc.querySelector("[data-hydration-key='lr-related']") ||
          doc.body;
        var related = section && section.querySelector("[data-hydration-key='lr-related']");
        if (!related && section && section.querySelector(".lr-product-grid")) {
          related = section;
        }
        if (!related || !related.querySelector(".lr-product-card, [data-lr-product-card]")) {
          return;
        }
        mount.innerHTML = "";
        mount.appendChild(related);
        if (window.lrBindQuickAdd) {
          mount.querySelectorAll("[data-lr-product-card]").forEach(window.lrBindQuickAdd);
        }
      })
      .catch(function () {
        /* keep collection fallback */
      });
  }

  document.querySelectorAll("[data-lr-related]").forEach(loadRelated);
})();

/* ── Shop browser (ShopBrowser.tsx parity) ─────────────────────── */
(function () {
  function pad2(n) {
    n = Math.max(0, parseInt(n, 10) || 0);
    return n < 10 ? "0" + n : String(n);
  }

  function moneyINR(n) {
    return "₹" + (parseInt(n, 10) || 0).toLocaleString("en-IN");
  }

  function splitCsv(s) {
    if (!s) return [];
    return String(s)
      .split(",")
      .map(function (x) { return x.trim(); })
      .filter(Boolean);
  }

  var LR_COLOUR_HEX = {
    black: "#111214",
    "washed black": "#111214",
    charcoal: "#2B2D31",
    "washed charcoal": "#2B2D31",
    grey: "#5A5D61",
    gray: "#5A5D61",
    concrete: "#5A5D61",
    white: "#F4F1EA",
    bone: "#E9E4D8",
    ivory: "#E9E4D8",
    cream: "#E9E4D8",
    navy: "#1B2430",
    blue: "#4AA3C7",
    red: "#B42318",
    olive: "#3F4A32",
  };

  function colourHex(name, override) {
    var raw = override ? String(override).trim() : "";
    if (raw && raw !== "#333" && raw !== "#333333" && raw !== "rgb(51, 51, 51)") return raw;
    var key = String(name || "").trim().toLowerCase();
    return LR_COLOUR_HEX[key] || "#5A5D61";
  }

  function readState(root) {
    return {
      type: root.dataset.filterType || "",
      sizes: splitCsv(root.dataset.filterSizes || ""),
      colours: splitCsv(root.dataset.filterColours || ""),
      maxPrice: parseInt(root.dataset.filterMax || root.dataset.maxPrice || "0", 10) || 0,
      stock: root.dataset.filterStock === "1",
      sort: root.dataset.filterSort || "featured",
      visible: parseInt(root.dataset.visible || root.dataset.pageSize || "9", 10) || 9,
    };
  }

  function writeState(root, state, opts) {
    root.dataset.filterType = state.type || "";
    root.dataset.filterSizes = state.sizes.join(",");
    root.dataset.filterColours = state.colours.join(",");
    root.dataset.filterMax = String(state.maxPrice);
    root.dataset.filterStock = state.stock ? "1" : "0";
    root.dataset.filterSort = state.sort;
    root.dataset.visible = String(state.visible);
    if (!opts || opts.syncUrl !== false) syncUrl(state, root);
  }

  function syncUrl(state, root) {
    try {
      var facetsMax = parseInt(root.dataset.maxPrice || "10000", 10) || 10000;
      var params = new URLSearchParams();
      if (state.type) params.set("type", state.type);
      if (state.sizes.length) params.set("sizes", state.sizes.join(","));
      if (state.colours.length) params.set("colours", state.colours.join(","));
      if (state.maxPrice && state.maxPrice < facetsMax) params.set("max", String(state.maxPrice));
      if (state.stock) params.set("stock", "1");
      if (state.sort && state.sort !== "featured") params.set("sort", state.sort);
      var qs = params.toString();
      var next = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
      var current = window.location.pathname + window.location.search + window.location.hash;
      if (next !== current) history.replaceState(null, "", next);
    } catch (err) {
      /* ignore URL sync failures */
    }
  }

  function stateFromUrl(root) {
    try {
      var params = new URLSearchParams(window.location.search);
      var facetsMax = parseInt(root.dataset.maxPrice || "10000", 10) || 10000;
      var next = {};
      if (params.has("type")) next.type = params.get("type") || "";
      if (params.has("sizes")) next.sizes = splitCsv(params.get("sizes") || "");
      if (params.has("colours") || params.has("colors")) {
        next.colours = splitCsv(params.get("colours") || params.get("colors") || "");
      }
      if (params.has("max")) {
        var max = parseInt(params.get("max"), 10);
        if (!isNaN(max)) next.maxPrice = max;
      } else {
        next.maxPrice = facetsMax;
      }
      if (params.has("stock")) next.stock = params.get("stock") === "1";
      if (params.has("sort")) next.sort = params.get("sort") || "featured";
      return next;
    } catch (err) {
      return {};
    }
  }

  function toggleList(list, value) {
    return list.indexOf(value) >= 0 ? list.filter(function (x) { return x !== value; }) : list.concat([value]);
  }

  function getItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll("[data-lr-shop-item]"));
  }

  function itemData(el) {
    return {
      el: el,
      type: el.getAttribute("data-type") || "",
      sizes: splitCsv(el.getAttribute("data-sizes")),
      colours: splitCsv(el.getAttribute("data-colours")),
      colourHexes: splitCsv(el.getAttribute("data-colour-hexes")),
      price: parseInt(el.getAttribute("data-price") || "0", 10) || 0,
      available: el.getAttribute("data-available") === "1",
      created: parseInt(el.getAttribute("data-created") || "0", 10) || 0,
      featured: parseInt(el.getAttribute("data-featured") || "0", 10) || 0,
    };
  }

  function buildFacets(items) {
    var types = {};
    var sizes = {};
    var colours = {};
    var maxPrice = 0;
    items.forEach(function (item) {
      if (item.type) types[item.type] = true;
      item.sizes.forEach(function (s) { sizes[s] = true; });
      item.colours.forEach(function (c, i) {
        if (!colours[c]) colours[c] = colourHex(c, item.colourHexes[i]);
      });
      if (item.price > maxPrice) maxPrice = item.price;
    });
    return {
      types: Object.keys(types).sort(),
      sizes: Object.keys(sizes),
      colours: Object.keys(colours).map(function (name) { return { name: name, hex: colours[name] }; }),
      maxPrice: maxPrice || parseInt(items[0] && items[0].el.closest("[data-lr-shop-browser]").dataset.maxPrice || "10000", 10),
    };
  }

  function filterSort(items, state) {
    var next = items.filter(function (item) {
      if (state.type && item.type !== state.type) return false;
      if (state.sizes.length && !state.sizes.some(function (s) { return item.sizes.indexOf(s) >= 0; })) return false;
      if (state.colours.length && !state.colours.some(function (c) { return item.colours.indexOf(c) >= 0; })) return false;
      if (item.price > state.maxPrice) return false;
      if (state.stock && !item.available) return false;
      return true;
    });
    next.sort(function (a, b) {
      if (state.sort === "newest") return b.created - a.created;
      if (state.sort === "price-asc") return a.price - b.price;
      if (state.sort === "price-desc") return b.price - a.price;
      return a.featured - b.featured;
    });
    return next;
  }

  function activeCount(state, facetsMax) {
    return (
      state.sizes.length +
      state.colours.length +
      (state.type ? 1 : 0) +
      (state.stock ? 1 : 0) +
      (state.maxPrice < facetsMax ? 1 : 0)
    );
  }

  function renderFilters(root, facets, state) {
    var panels = root.querySelectorAll("[data-lr-shop-filters]");
    panels.forEach(function (panel) {
      var cats = panel.querySelector("[data-lr-filter-cats]");
      if (cats) {
        cats.innerHTML = "";
        var allBtn = document.createElement("button");
        allBtn.type = "button";
        allBtn.className = "lr-tech lr-shop-filters__cat" + (!state.type ? " is-active is-all" : "");
        allBtn.setAttribute("data-lr-cat", "");
        allBtn.setAttribute("aria-pressed", !state.type ? "true" : "false");
        allBtn.textContent = "All";
        cats.appendChild(allBtn);
        facets.types.forEach(function (t) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "lr-tech lr-shop-filters__cat" + (state.type === t ? " is-active" : "");
          btn.setAttribute("data-lr-cat", t);
          btn.setAttribute("aria-pressed", state.type === t ? "true" : "false");
          btn.textContent = t;
          cats.appendChild(btn);
        });
      }

      var sizeGroup = panel.querySelector("[data-lr-size-group]");
      var sizesEl = panel.querySelector("[data-lr-filter-sizes]");
      if (sizeGroup && sizesEl) {
        if (!facets.sizes.length) {
          sizeGroup.hidden = true;
        } else {
          sizeGroup.hidden = false;
          sizesEl.innerHTML = "";
          facets.sizes.forEach(function (s) {
            var btn = document.createElement("button");
            btn.type = "button";
            btn.className = "lr-shop-filters__size" + (state.sizes.indexOf(s) >= 0 ? " is-active" : "");
            btn.setAttribute("data-lr-size", s);
            btn.setAttribute("aria-pressed", state.sizes.indexOf(s) >= 0 ? "true" : "false");
            btn.textContent = s;
            sizesEl.appendChild(btn);
          });
        }
      }

      var colourGroup = panel.querySelector("[data-lr-colour-group]");
      var coloursEl = panel.querySelector("[data-lr-filter-colours]");
      if (colourGroup && coloursEl) {
        if (!facets.colours.length) {
          colourGroup.hidden = true;
        } else {
          colourGroup.hidden = false;
          coloursEl.innerHTML = "";
          facets.colours.forEach(function (c) {
            var btn = document.createElement("button");
            btn.type = "button";
            btn.className = "lr-shop-filters__colour" + (state.colours.indexOf(c.name) >= 0 ? " is-active" : "");
            btn.setAttribute("data-lr-colour", c.name);
            btn.setAttribute("aria-pressed", state.colours.indexOf(c.name) >= 0 ? "true" : "false");
            btn.innerHTML =
              '<span class="lr-shop-filters__swatch" style="background:' +
              c.hex +
              '" aria-hidden="true"></span><span class="lr-tech' +
              (state.colours.indexOf(c.name) >= 0 ? " lr-tech--accent" : "") +
              '">' +
              c.name +
              "</span>";
            coloursEl.appendChild(btn);
          });
        }
      }

      var range = panel.querySelector("[data-lr-max-price]");
      var label = panel.querySelector("[data-lr-price-label]");
      if (range) {
        range.max = String(Math.max(facets.maxPrice, 1));
        range.value = String(state.maxPrice);
      }
      if (label) label.textContent = "UP TO " + moneyINR(state.maxPrice);

      var stock = panel.querySelector("[data-lr-stock]");
      if (stock) stock.checked = state.stock;

      var clear = panel.querySelector("[data-lr-clear]");
      var count = activeCount(state, facets.maxPrice);
      if (clear) {
        clear.classList.toggle("hidden", count === 0);
        var cEl = clear.querySelector("[data-lr-clear-count]");
        if (cEl) cEl.textContent = String(count);
      }
    });
  }

  function render(root) {
    var pageSize = parseInt(root.dataset.pageSize || "9", 10) || 9;
    var facetsMax = parseInt(root.dataset.maxPrice || "10000", 10) || 10000;
    var items = getItems(root).map(itemData);
    var facets = buildFacets(items);
    if (facets.maxPrice > facetsMax) {
      root.dataset.maxPrice = String(facets.maxPrice);
      facetsMax = facets.maxPrice;
    }
    var state = readState(root);
    if (!state.maxPrice) state.maxPrice = facetsMax;

    var matched = filterSort(items, state);
    var shown = matched.slice(0, state.visible);
    var remaining = matched.length - shown.length;

    var grid = root.querySelector("[data-lr-shop-grid-el]");
    var empty = root.querySelector("[data-lr-shop-empty]");

    /* Re-order DOM to match sorted results — toggling [hidden] alone keeps
       CSS grid in collection order, so price/newest sort looked broken. */
    if (grid) {
      matched.forEach(function (item) {
        grid.appendChild(item.el);
      });
      items.forEach(function (item) {
        var kept = matched.some(function (m) {
          return m.el === item.el;
        });
        if (!kept) grid.appendChild(item.el);
      });
    }

    items.forEach(function (item) {
      item.el.hidden = true;
    });
    shown.forEach(function (item) {
      item.el.hidden = false;
    });

    if (grid) grid.classList.toggle("hidden", matched.length === 0);
    if (empty) empty.classList.toggle("hidden", matched.length !== 0);

    var countEl = root.querySelector("[data-lr-item-count]");
    if (countEl) countEl.textContent = String(matched.length);

    var badge = root.querySelector("[data-lr-filter-badge]");
    var count = activeCount(state, facetsMax);
    if (badge) {
      badge.classList.toggle("hidden", count === 0);
      badge.textContent = count ? "(" + count + ")" : "";
    }

    var moreWrap = root.querySelector("[data-lr-load-more-wrap]");
    var remEl = root.querySelector("[data-lr-remaining]");
    if (moreWrap) moreWrap.classList.toggle("hidden", remaining <= 0);
    if (remEl) remEl.textContent = String(remaining);

    root.querySelectorAll("[data-lr-drawer-count]").forEach(function (el) {
      el.textContent = pad2(matched.length);
    });

    var sortEl = root.querySelector("[data-lr-sort]");
    if (sortEl) sortEl.value = state.sort;

    renderFilters(root, facets, state);
    writeState(root, state);
  }

  function patch(root, next) {
    var state = readState(root);
    Object.keys(next).forEach(function (k) {
      state[k] = next[k];
    });
    if (next.type !== undefined || next.sizes || next.colours || next.maxPrice !== undefined || next.stock !== undefined || next.sort) {
      if (next.visible === undefined) state.visible = parseInt(root.dataset.pageSize || "9", 10) || 9;
    }
    writeState(root, state);
    render(root);
  }

  function bindRoot(root) {
    if (root.dataset.lrShopBound === "1") return;
    root.dataset.lrShopBound = "1";

    var facetsMax = parseInt(root.dataset.maxPrice || "10000", 10) || 10000;
    root.dataset.filterMax = String(facetsMax);
    root.dataset.visible = root.dataset.pageSize || "9";
    root.dataset.filterSort = "featured";

    var fromUrl = stateFromUrl(root);
    Object.keys(fromUrl).forEach(function (k) {
      if (fromUrl[k] === undefined) return;
      if (k === "sizes" || k === "colours") {
        root.dataset[k === "sizes" ? "filterSizes" : "filterColours"] = (fromUrl[k] || []).join(",");
      } else if (k === "type") {
        root.dataset.filterType = fromUrl[k] || "";
      } else if (k === "maxPrice") {
        root.dataset.filterMax = String(fromUrl[k]);
      } else if (k === "stock") {
        root.dataset.filterStock = fromUrl[k] ? "1" : "0";
      } else if (k === "sort") {
        root.dataset.filterSort = fromUrl[k] || "featured";
      }
    });

    var asideFilters = root.querySelector("[data-lr-filters-aside] [data-lr-shop-filters]");
    var drawerSlot = root.querySelector("[data-lr-drawer-filters]");
    if (asideFilters && drawerSlot && !drawerSlot.children.length) {
      drawerSlot.appendChild(asideFilters.cloneNode(true));
    }

    render(root);

    root.addEventListener("click", function (e) {
      var t = e.target.closest("[data-lr-cat], [data-lr-size], [data-lr-colour], [data-lr-clear], [data-lr-load-more], [data-lr-filter-open], [data-lr-filter-close]");
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute("data-lr-filter-open")) {
        var drawer = root.querySelector("[data-lr-filter-drawer]");
        if (drawer) {
          drawer.hidden = false;
          document.body.style.overflow = "hidden";
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              drawer.classList.add("is-open");
            });
          });
        }
        return;
      }
      if (t.hasAttribute("data-lr-filter-close")) {
        var d = root.querySelector("[data-lr-filter-drawer]");
        if (d) {
          d.classList.remove("is-open");
          document.body.style.overflow = "";
          window.setTimeout(function () {
            d.hidden = true;
          }, 320);
        }
        return;
      }
      if (t.hasAttribute("data-lr-load-more")) {
        var st = readState(root);
        var pageSize = parseInt(root.dataset.pageSize || "9", 10) || 9;
        patch(root, { visible: st.visible + pageSize });
        return;
      }
      if (t.hasAttribute("data-lr-clear")) {
        patch(root, {
          type: "",
          sizes: [],
          colours: [],
          maxPrice: parseInt(root.dataset.maxPrice || "10000", 10) || 10000,
          stock: false,
          visible: parseInt(root.dataset.pageSize || "9", 10) || 9,
        });
        return;
      }
      if (t.hasAttribute("data-lr-cat")) {
        patch(root, { type: t.getAttribute("data-lr-cat") || "" });
        return;
      }
      if (t.hasAttribute("data-lr-size")) {
        var s = readState(root);
        patch(root, { sizes: toggleList(s.sizes, t.getAttribute("data-lr-size") || "") });
        return;
      }
      if (t.hasAttribute("data-lr-colour")) {
        var c = readState(root);
        patch(root, { colours: toggleList(c.colours, t.getAttribute("data-lr-colour") || "") });
      }
    });

    root.addEventListener("change", function (e) {
      var t = e.target;
      if (t.matches("[data-lr-sort]")) {
        patch(root, { sort: t.value });
      } else if (t.matches("[data-lr-stock]")) {
        patch(root, { stock: t.checked });
      } else if (t.matches("[data-lr-max-price]")) {
        patch(root, { maxPrice: parseInt(t.value, 10) || 0 });
      }
    });

    root.addEventListener("input", function (e) {
      var t = e.target;
      if (!t.matches("[data-lr-max-price]")) return;
      root.querySelectorAll("[data-lr-price-label]").forEach(function (label) {
        label.textContent = "UP TO " + moneyINR(t.value);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var d = root.querySelector("[data-lr-filter-drawer]");
      if (d && !d.hidden) {
        d.classList.remove("is-open");
        document.body.style.overflow = "";
        window.setTimeout(function () {
          d.hidden = true;
        }, 320);
      }
    });
  }

  document.querySelectorAll("[data-lr-shop-browser]").forEach(bindRoot);
})();

/* Reelfy stacked carousel: keep Flickity centered after layout / aspect morph */
(function () {
  var MORPH_MS = 520;
  var bound = typeof WeakSet !== "undefined" ? new WeakSet() : null;

  var getFlkty = function (el) {
    if (!el || !window.Flickityrf || typeof window.Flickityrf.data !== "function") {
      return null;
    }
    return window.Flickityrf.data(el);
  };

  var resizeEl = function (el) {
    var flkty = getFlkty(el);
    if (!flkty || typeof flkty.resize !== "function") return;
    flkty.resize();
    if (typeof flkty.reposition === "function") flkty.reposition();
  };

  var resizeAll = function () {
    document
      .querySelectorAll(".reelfy-gallery .flickityrf-enabled")
      .forEach(resizeEl);
  };

  var schedule = function () {
    window.requestAnimationFrame(function () {
      resizeAll();
      window.setTimeout(resizeAll, MORPH_MS);
    });
  };

  var bindCarousel = function (el) {
    if (!el) return;
    if (bound) {
      if (bound.has(el)) return;
      bound.add(el);
    } else if (el.getAttribute("data-lr-rf-bound") === "1") {
      return;
    } else {
      el.setAttribute("data-lr-rf-bound", "1");
    }

    var flkty = getFlkty(el);
    if (flkty && typeof flkty.on === "function") {
      flkty.on("select", schedule);
      flkty.on("settle", schedule);
    }

    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(function () {
        resizeEl(el);
      });
      ro.observe(el);
      var section = el.closest(".reelfy-section, .shopify-block");
      if (section) ro.observe(section);
    }

    resizeEl(el);
  };

  var scan = function () {
    document
      .querySelectorAll(".reelfy-gallery .flickityrf-enabled")
      .forEach(bindCarousel);
  };

  var start = function () {
    scan();
    schedule();
    window.addEventListener("load", schedule);
    window.addEventListener("resize", schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule).catch(function () {});
    }

    var mo = new MutationObserver(function () {
      scan();
    });
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

/* ── Analytics readiness (Shopify Customer Events + custom bus) ─
   Does not add third-party pixels. Wire GA/Meta later by listening
   to `lr:analytics` or Shopify.analytics.publish consumers. */
(function () {
  if (window.LRAnalytics) return;

  window.LRAnalytics = {
    track: function (eventName, payload) {
      var detail = payload && typeof payload === "object" ? payload : {};
      try {
        if (
          window.Shopify &&
          Shopify.analytics &&
          typeof Shopify.analytics.publish === "function"
        ) {
          Shopify.analytics.publish(eventName, detail);
        }
      } catch (err) {
        /* ignore publish failures */
      }
      try {
        document.dispatchEvent(
          new CustomEvent("lr:analytics", {
            detail: { event: eventName, payload: detail },
          })
        );
      } catch (err2) {
        /* ignore */
      }
    },
  };

  document.addEventListener("shopify:cart:lines-update", function (event) {
    if (!window.LRAnalytics) return;
    window.LRAnalytics.track("cart_viewed_or_updated", {
      action: event.action || "update",
    });
  });
})();

/* ---- Keep cart discounts current ----
   Shopify only re-evaluates discounts when the cart changes, so a cart filled
   before a discount was edited keeps the old one until it is touched. Once per
   session, nudge the cart and redraw if the discounts came back different. */
(function () {
  var state = window.LR_CART;
  if (!state || !state.count) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var KEY = "lr_cart_discount_sync";
  try {
    if (sessionStorage.getItem(KEY)) return;
    sessionStorage.setItem(KEY, "1");
  } catch (storageErr) {
    return;
  }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function updateCart(body) {
    return fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error("Cart sync failed");
      return r.json();
    });
  }

  function signature(cart) {
    var titles = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.title) titles.push(d.title);
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title;
        if (t) titles.push(t);
      });
    });
    titles = titles
      .filter(function (t, i) {
        return titles.indexOf(t) === i;
      })
      .sort();
    return cart.total_price + "|" + cart.total_discount + "|" + titles.join("||");
  }

  updateCart({ attributes: { _lr_sync: String(Date.now()) } })
    .then(function () {
      return updateCart({
        attributes: { _lr_sync: "" },
        sections: "cart-drawer-section",
        sections_url: window.location.pathname,
      });
    })
    .then(function (cart) {
      if (signature(cart) === state.sig) return;

      if (document.querySelector(".lr-page-cart")) {
        window.location.reload();
        return;
      }

      var event = new CustomEvent("shopify:cart:lines-update", { bubbles: true, cancelable: false });
      event.action = "update";
      event.promise = Promise.resolve({
        cart: { totalQuantity: cart.item_count, id: cart.token },
        detail: {
          sections: cart.sections || {},
          items: cart.items,
          itemCount: cart.item_count,
          source: "lr-discount-sync",
          didError: false,
        },
      });
      document.dispatchEvent(event);
    })
    .catch(function () {});
})();

/* ---- Pre-launch waitlist ---- */
(function () {
    if (!window.LR_PRE_LAUNCH) return;

  // Ensure no purchasable cart residual during pre-launch
  try {
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart/clear.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    }).catch(function () {});
  } catch (clearErr) {}

  var STORAGE_KEY = "lr_waitlist_email";
  var root = document.querySelector("[data-lr-waitlist]");
  if (!root) return;

  var panel = root.querySelector("[data-lr-waitlist-panel]");
  var form = root.querySelector("#lr-waitlist-form");
  var emailInput = root.querySelector("[data-lr-waitlist-email]");
  var errEl = root.querySelector("[data-lr-waitlist-error]");
  var submitBtn = root.querySelector("[data-lr-waitlist-submit]");
  var formView = root.querySelector('[data-lr-waitlist-view="form"]');
  var successView = root.querySelector('[data-lr-waitlist-view="success"]');
  var successTitle = root.querySelector("[data-lr-waitlist-success-title]");
  var successBody = root.querySelector("[data-lr-waitlist-success-body]");
  var lastProduct = "";
  var lastFocus = null;

  function track(name, payload) {
    if (window.LRAnalytics && typeof window.LRAnalytics.track === "function") {
      window.LRAnalytics.track(name, payload || {});
    }
  }

  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg || "";
    errEl.hidden = !msg;
    errEl.classList.toggle("hidden", !msg);
  }

  function setView(which) {
    var isSuccess = which === "success";
    if (formView) {
      formView.hidden = isSuccess;
      formView.classList.toggle("hidden", isSuccess);
    }
    if (successView) {
      successView.hidden = !isSuccess;
      successView.classList.toggle("hidden", !isSuccess);
    }
  }

  function openWaitlist(productHandle) {
    lastProduct = productHandle || "";
    lastFocus = document.activeElement;
    showError("");
    setView("form");
    root.hidden = false;
    root.classList.remove("hidden");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("lr-waitlist-open");
    if (window.LRFocusTrap) {
      window.LRFocusTrap.activate(panel, emailInput);
    } else if (emailInput) {
      window.setTimeout(function () {
        emailInput.focus();
      }, 0);
    }
    /* Wire hCaptcha while modal is visible (hidden forms often miss auto-wire) */
    try {
      if (form && window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === "function") {
        Shopify.captcha.protect(form);
      }
    } catch (capOpenErr) {}
    track("waitlist_view", { product: lastProduct || null });
  }

  function closeWaitlist() {
    root.hidden = true;
    root.classList.add("hidden");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("lr-waitlist-open");
    if (window.LRFocusTrap) window.LRFocusTrap.deactivate();
    if (lastFocus && typeof lastFocus.focus === "function") {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }

  function storedEmail() {
    try {
      return (window.localStorage.getItem(STORAGE_KEY) || "").toLowerCase();
    } catch (e) {
      return "";
    }
  }

  function rememberEmail(email) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(email).toLowerCase());
    } catch (e) {}
  }

  function showAlreadyIn() {
    if (successTitle) successTitle.textContent = "You're already in.";
    if (successBody) {
      successBody.textContent =
        "You're already on the list for " + (window.LR_PRE_LAUNCH_DROP || "Drop 001") + ".";
    }
    setView("success");
  }

  function showSuccess() {
    if (successTitle) successTitle.textContent = "You're in.";
    if (successBody) {
      successBody.textContent =
        "You'll be among the first to know when " +
        (window.LR_PRE_LAUNCH_DROP || "Drop 001") +
        " goes live.";
    }
    setView("success");
  }

  function clearWaitlistQuery() {
    try {
      var url = new URL(window.location.href);
      var dirty = false;
      ["waitlist", "customer_posted", "contact_posted", "form_type"].forEach(function (key) {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          dirty = true;
        }
      });
      if (url.hash === "#lr-waitlist-form" || url.hash === "#ContactForm") {
        url.hash = "";
        dirty = true;
      }
      if (!dirty) return;
      var next = url.pathname + (url.search ? url.search : "") + url.hash;
      window.history.replaceState({}, "", next);
    } catch (e) {}
  }

  var frame = document.querySelector("[data-lr-waitlist-frame]");
  var submitting = false;
  var enrollLock = false;
  var pendingEmail = "";
  var frameTimer = null;

  function resetSubmitUi() {
    submitting = false;
    enrollLock = false;
    pendingEmail = "";
    if (frameTimer) {
      window.clearTimeout(frameTimer);
      frameTimer = null;
    }
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = "Get early access";
    }
  }

  function finishWaitlistSuccess(email, duplicate) {
    rememberEmail(email);
    if (duplicate) showAlreadyIn();
    else showSuccess();
    clearWaitlistQuery();
    track("waitlist_success", { duplicate: !!duplicate, product: lastProduct || null });
    resetSubmitUi();
  }

  /*
    Native POST into hidden iframe — required so Shopify can attach hCaptcha.
    form.submit() does not fire the submit event (so our preventDefault won't block it).
  */
  function postWaitlistNative(email) {
    if (submitting || !form) return;
    submitting = true;
    pendingEmail = email;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Sending…";
    }

    form.setAttribute("target", "lr-waitlist-frame");

    try {
      HTMLFormElement.prototype.submit.call(form);
    } catch (submitErr) {
      showError("Something went wrong. Try again in a moment.");
      track("waitlist_error", { reason: "submit" });
      resetSubmitUi();
      return;
    }

    /* Fallback if iframe onload is flaky */
    frameTimer = window.setTimeout(function () {
      if (!submitting) return;
      finishWaitlistSuccess(email, false);
    }, 4000);
  }

  function handleWaitlistEnroll() {
    if (enrollLock || submitting) return;
    enrollLock = true;

    var email = (emailInput && emailInput.value) || "";
    email = email.trim();

    if (!email) {
      enrollLock = false;
      showError("Enter your email.");
      if (emailInput) emailInput.focus();
      track("waitlist_error", { reason: "empty" });
      return;
    }
    if (!validEmail(email)) {
      enrollLock = false;
      showError("That email doesn't look right.");
      if (emailInput) emailInput.focus();
      track("waitlist_error", { reason: "invalid" });
      return;
    }

    var prev = storedEmail();
    if (prev && prev === email.toLowerCase()) {
      enrollLock = false;
      showAlreadyIn();
      track("waitlist_success", { duplicate: true, product: lastProduct || null });
      return;
    }

    showError("");
    track("waitlist_submit", { product: lastProduct || null });

    var run = function () {
      postWaitlistNative(email);
    };

    try {
      if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === "function") {
        Shopify.captcha.protect(form, run);
        return;
      }
    } catch (capErr) {}

    run();
  }

  if (frame) {
    frame.addEventListener("load", function () {
      if (!submitting || !pendingEmail) return;
      var email = pendingEmail;
      finishWaitlistSuccess(email, false);
    });
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-lr-waitlist-open]");
    if (openBtn) {
      e.preventDefault();
      track("early_access_click", {
        product: openBtn.getAttribute("data-lr-waitlist-product") || null,
        source: openBtn.tagName.toLowerCase(),
      });
      openWaitlist(openBtn.getAttribute("data-lr-waitlist-product") || "");
      return;
    }
    if (e.target.closest("[data-lr-waitlist-close]")) {
      e.preventDefault();
      closeWaitlist();
      return;
    }
    if (e.target.closest("[data-lr-waitlist-submit]")) {
      e.preventDefault();
      handleWaitlistEnroll();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !root.hidden) {
      closeWaitlist();
    }
  });

  /* Block top-level navigation from this form; intentional enroll uses form.submit() (no event) */
  if (form) {
    form.setAttribute("target", "lr-waitlist-frame");
    form.addEventListener(
      "submit",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleWaitlistEnroll();
      },
      true
    );
  }

  // Block residual ATC / checkout paths if markup still present
  document.addEventListener(
    "submit",
    function (e) {
      var formEl = e.target;
      if (!formEl || !formEl.closest) return;
      if (formEl.id === "lr-waitlist-form") return;
      if (formEl.querySelector('[name="add"]') || formEl.getAttribute("action") === "/cart/add") {
        e.preventDefault();
        openWaitlist("");
      }
    },
    true
  );

  /* Recover if an older build already redirected the parent */
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get("customer_posted") === "true") {
      clearWaitlistQuery();
      openWaitlist("");
      showSuccess();
    } else {
      clearWaitlistQuery();
    }
  } catch (err) {}
})();
